/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAdunit from 'base/components/standalone/Adunit';

export const DynamicStandaloneAdunit = StandaloneAdunit;
export type DynamicStandaloneAdunitProps = PropsFromComponent<typeof StandaloneAdunit>;

export const DynamicStandaloneAdunitWith = (extras: DynamicStandaloneExtras): typeof StandaloneAdunit => {
    return function DynamicStandaloneAdunit(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Adunit');
        return <StandaloneAdunit {...mergeProps({ options: { theme } }, props)} />;
    }
}